module.exports = __webpack_public_path__ + "static/media/field-design.1afe80b4.svg";